<template>
	<router-view></router-view>
</template>

<script>
export default {
	name: 'app'
};
</script>


// WEBPACK FOOTER //
// App.vue?cb74a6e4